import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "ANC", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_layout_header = _resolveComponent("n-layout-header")!
  const _component_n_menu = _resolveComponent("n-menu")!
  const _component_n_layout_sider = _resolveComponent("n-layout-sider")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_n_layout_content = _resolveComponent("n-layout-content")!
  const _component_n_layout = _resolveComponent("n-layout")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createBlock(_component_n_space, { vertical: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_n_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_layout, { "has-sider": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_n_layout_sider, {
                class: "h-screen",
                bordered: "",
                "show-trigger": "",
                "collapse-mode": "width",
                "collapsed-width": 64,
                width: 240,
                "native-scrollbar": false,
                inverted: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_layout_header, {
                    inverted: true,
                    class: "pl-4 pt-2 font-bold text-lg"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_icon, { name: "menu" }),
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_n_menu, {
                    class: "select-none",
                    inverted: true,
                    "collapsed-width": 64,
                    "collapsed-icon-size": 22,
                    options: _ctx.menuOptions,
                    "onUpdate:value": _ctx.onPageChange,
                    "default-value": "arquivos"
                  }, null, 8, ["options", "onUpdate:value"])
                ]),
                _: 1
              }),
              _createVNode(_component_n_layout_content, {
                "content-style": "padding: 15px;",
                "native-scrollbar": false,
                class: "max-h-screen"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}